// extracted by mini-css-extract-plugin
module.exports = {"logo":"Spinner_logo__1upxe","container":"Spinner_container__1HJ4-","spinner":"Spinner_spinner__2UOjX","rotate":"Spinner_rotate__1E3mO"};